<template>
  <div>
    <b-row>
      <b-col cols="2">
        <b-button  variant="success" @click="showAddTechnicalParameters">{{ $t('Add') }}</b-button>
      </b-col>
      <b-col cols="6">
        <b-form-group :label="$t('Select account')" label-cols="4" label-cols-xl="4" label-cols-md="4">
          <b-form-select v-model="selectedAccount" :options="currentRow.accounts">
          </b-form-select>
        </b-form-group>
      </b-col>
    </b-row>
    <b-table small striped hover :items="TechnicalParameters" :fields="TechnicalParametersFields" @row-clicked="rowTechnicalParametersClickHandler">
       <template v-slot:cell(actions)="row">
        <b-button size="sm" @click.stop="ClickOnDeleteTechnicalParametersButton(row)" id="transparent">
          <b-img :src='deleteDocumentImage' />
        </b-button>
        <b-button size="sm" @click.stop="ClickOnEditTechnicalParametersButton(row)" id="transparent">
          <b-img :src='editDocumentImage' />
        </b-button>
      </template>
    </b-table>

    <b-modal hide-footer :title="$t('Parameters')" ref="modalAddTechnicalParameters" @hidden="isShowAddTechParams = false" @show="isShowAddTechParams = true">
      <FormAdd v-if="isShowAddTechParams"
      @hideAddTechnicalParameters="hideAddTechnicalParameters"
      @makeToasts="makeToasts"
      :currentRow="currentRow"
      :selectedAccount="selectedAccount"
      @refreshTable="reloadTechParams"
      :isEdit="isEdit"
      :currentRowTechnicalParameters="currentRowTechnicalParameters"/>
    </b-modal>

    <b-modal hide-footer :title="$t('Confirmation')" ref="modalDeleteTechnicalParameters">
      <h5>{{ $t('Are you sure you want to delete one of "Technical parameters"?') }}</h5>
      <b-row>
        <b-col>
          <b-button variant="danger" block @click="deleteTechnicalParameters()">Ok</b-button>
        </b-col>
        <b-col>
          <b-button variant="secondary" block @click="hideDeleteTechnicalParameters()">{{ $t('Cancel') }}</b-button>
        </b-col>
      </b-row>
    </b-modal>
  </div>
</template>

<script>

import axiosInstance from '@/utils/api.js'
import FormAdd from './formAdd.vue'

export default {
  components: {
    FormAdd
  },
  props: {
    currentRow: null
  },
  data () {
    return {
      currentRowTechnicalParameters: null,
      isEdit: false,
      isShowAddTechParams: false,
      deleteDocumentImage: require('@/assets/img/document_delete.png'),
      editDocumentImage: require('@/assets/img/document_edit.png'),
      listOfAccounts: [],
      selectedAccount: null,
      TechnicalParameters: [],
      TechnicalParametersFields: [
        { key: 'id', label: 'ID', sortable: true },
        { key: 'param', label: this.$i18n.t('Value'), sortable: true },
        { key: 'type_name', label: this.$i18n.t('Type'), sortable: true },
        { key: 'slink_id', label: this.$i18n.t('Link ID'), sortable: true },
        { key: 'service_name', label: this.$i18n.t('Service name'), sortable: true },
        { key: 'actions', label: this.$i18n.t('Actions') }
      ]
    }
  },
  methods: {
    ClickOnEditTechnicalParametersButton (row) {
      this.isEdit = true
      this.isShowAddTechParams = true
      this.currentRowTechnicalParameters = row.item
      this.$refs.modalAddTechnicalParameters.show()
    },
    ClickOnDeleteTechnicalParametersButton (row) {
      this.currentRowTechnicalParameters = row.item
      this.$refs.modalDeleteTechnicalParameters.show()
    },
    hideDeleteTechnicalParameters () {
      this.$refs.modalDeleteTechnicalParameters.hide()
    },
    deleteTechnicalParameters () {
      if (this.currentRowTechnicalParameters) {
        axiosInstance.delete(this.$store.getters.API_USERS_TECH_PARAMS + '?tech_param_id=' + this.currentRowTechnicalParameters.id + '&slink_id=' + this.currentRowTechnicalParameters.slink_id)
        this.$root.$emit('makeToasts')
        this.$refs.modalDeleteTechnicalParameters.hide()
        this.reloadTechParams()
      }
    },
    rowTechnicalParametersClickHandler (row) {
      if (this.currentRowTechnicalParameters) {
        this.currentRowTechnicalParameters._rowVariant = ''
      }
      this.currentRowTechnicalParameters = row
      this.$set(this.currentRowTechnicalParameters, '_rowVariant', 'info')
    },
    makeToasts (variant, body, title) {
      this.$root.$emit('makeToasts', variant, body, title)
    },
    load () {
      this.selectedAccount = this.currentRow.accounts.length ? this.currentRow.accounts[0] : null
    },
    async reloadTechParams () {
      if (this.selectedAccount) {
        this.TechnicalParameters = await axiosInstance.get(this.$store.getters.API_USERS_TECH_PARAMS + '?user_id=' + this.currentRow.user_id + '&account_id=' + this.selectedAccount).then(response => { return response.data })
      }
    },
    showAddTechnicalParameters () {
      this.isEdit = false
      this.isShowAddTechParams = true
      this.$refs.modalAddTechnicalParameters.show()
    },
    hideAddTechnicalParameters () {
      this.isShowAddTechParams = false
      this.$refs.modalAddTechnicalParameters.hide()
    }
  },
  watch: {
    selectedAccount: function () {
      this.reloadTechParams()
    }
  },
  mounted () {
    this.load()
  }
}
</script>



// WEBPACK FOOTER //
// src/pages/users/usersAndGroups/detail/technicalParameters/main.vue